import React from "react";
import {
  Target,
  Eye,
  Award,
  TrendingUp,
  Shield,
  CheckCircle,
  ChevronRight,
} from "lucide-react";

export default function Nosotros() {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <section
        className="relative py-16 md:py-32"
        style={{
          backgroundImage:
            "url(https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2069)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-allti-blue/90 via-gray-900/85 to-allti-blue/90"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto text-center text-white">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-4 md:px-6 py-2 md:py-3 rounded-full mb-6 md:mb-8">
              <span className="text-white font-semibold text-sm md:text-base">
                Partner Certificado HPE desde 2010
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">
              Expertos en Infraestructura TI Empresarial
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-gray-200 max-w-3xl mx-auto mb-6 md:mb-8">
              Más de 15 años transformando empresas con soluciones HPE de clase
              mundial
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6 mt-8 md:mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-6 border border-white/20">
                <p className="text-2xl md:text-4xl font-bold text-allti-blue mb-1 md:mb-2">
                  15+
                </p>
                <p className="text-gray-200 text-xs md:text-sm">
                  Años de experiencia
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-6 border border-white/20">
                <p className="text-2xl md:text-4xl font-bold text-hpe-green mb-1 md:mb-2">
                  200+
                </p>
                <p className="text-gray-200 text-xs md:text-sm">
                  Clientes satisfechos
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-6 border border-white/20">
                <p className="text-2xl md:text-4xl font-bold text-allti-blue mb-1 md:mb-2">
                  500+
                </p>
                <p className="text-gray-200 text-xs md:text-sm">
                  Proyectos exitosos
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-3 md:p-6 border border-white/20">
                <p className="text-2xl md:text-4xl font-bold text-hpe-green mb-1 md:mb-2">
                  24/7
                </p>
                <p className="text-gray-200 text-xs md:text-sm">
                  Soporte continuo
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Nuestra Historia */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Nuestra Historia
              </h2>
              <p className="text-lg text-gray-600 mb-4">
                ALLTI nació con la visión de transformar la manera en que las
                empresas gestionan su infraestructura tecnológica. Desde
                nuestros inicios, nos hemos especializado en soluciones HPE,
                convirtiéndonos en socios estratégicos de empresas que buscan
                excelencia en tecnología.
              </p>
              <p className="text-lg text-gray-600 mb-4">
                Con años de experiencia en el sector, hemos ayudado a cientos de
                organizaciones a optimizar sus operaciones, reducir costos y
                acelerar su transformación digital mediante soluciones robustas
                y escalables.
              </p>
              <p className="text-lg text-gray-600">
                Nuestro equipo de expertos certificados trabaja día a día para
                ofrecer soluciones innovadoras que impulsen el crecimiento de
                nuestros clientes.
              </p>
            </div>
            <div>
              <img
                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzYxMDcxODQ2fDA&ixlib=rb-4.1.0&q=85"
                alt="Corporate Building"
                className="rounded-xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Misión y Visión */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div
              className="bg-white p-10 rounded-xl shadow-lg"
              data-testid="mision-card"
            >
              <div className="bg-allti-blue/10 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                <Target className="text-allti-blue" size={32} />
              </div>
              <h3 className="text-3xl font-bold mb-4 text-gray-900">
                Nuestra Misión
              </h3>
              <p className="text-lg text-gray-600">
                Proporcionar soluciones de infraestructura TI de clase mundial
                que permitan a las empresas alcanzar sus objetivos de
                transformación digital, optimizando recursos y maximizando el
                retorno de inversión a través de tecnología HPE de vanguardia.
              </p>
            </div>

            <div
              className="bg-white p-10 rounded-xl shadow-lg"
              data-testid="vision-card"
            >
              <div className="bg-allti-red/10 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                <Eye className="text-allti-red" size={32} />
              </div>
              <h3 className="text-3xl font-bold mb-4 text-gray-900">
                Nuestra Visión
              </h3>
              <p className="text-lg text-gray-600">
                Ser el socio tecnológico preferido en América Latina para
                soluciones de infraestructura TI, reconocidos por nuestra
                excelencia técnica, innovación continua y compromiso
                inquebrantable con el éxito de nuestros clientes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Valores */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nuestros Valores
            </h2>
            <p className="text-xl text-gray-600">
              Los principios que guían nuestro trabajo diario
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-allti-blue/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Award className="text-allti-blue" size={36} />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">
                Excelencia
              </h3>
              <p className="text-gray-600">
                Nos comprometemos con la máxima calidad en cada proyecto,
                superando las expectativas de nuestros clientes.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-allti-red/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <Shield className="text-allti-red" size={36} />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">
                Confianza
              </h3>
              <p className="text-gray-600">
                Construimos relaciones duraderas basadas en la transparencia,
                honestidad y resultados comprobables.
              </p>
            </div>

            <div className="text-center">
              <div className="bg-hpe-green/10 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                <TrendingUp className="text-hpe-green" size={36} />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900">
                Innovación
              </h3>
              <p className="text-gray-600">
                Adoptamos las últimas tecnologías y metodologías para ofrecer
                soluciones vanguardistas.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Equipo */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nuestro Equipo
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Profesionales certificados y apasionados por la tecnología
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxJVCUyMHRlYW18ZW58MHx8fHwxNzYxMDcxODUxfDA&ixlib=rb-4.1.0&q=85"
                alt="IT Team"
                className="rounded-xl shadow-2xl"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Expertos Certificados
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Nuestro equipo está conformado por ingenieros certificados en
                soluciones HPE, con amplia experiencia en diseño, implementación
                y soporte de infraestructuras críticas.
              </p>
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="bg-allti-blue text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl">
                    15+
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">
                      Años de Experiencia
                    </p>
                    <p className="text-gray-600">En soluciones empresariales</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="bg-allti-red text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl">
                    50+
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">
                      Proyectos Exitosos
                    </p>
                    <p className="text-gray-600">
                      Implementados en diversos sectores
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="bg-hpe-green text-white w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl">
                    100%
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Satisfacción</p>
                    <p className="text-gray-600">De nuestros clientes</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ecosistema HPE */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-block bg-hpe-green/10 px-6 py-2 rounded-full mb-4">
              <span className="text-hpe-green font-semibold">
                Partner Certificado HPE
              </span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Ecosistema de Tecnologías HPE
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Implementamos las mejores soluciones del portafolio HPE y su
              ecosistema de marcas líderes
            </p>
          </div>

          {/* Grid de Logos */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow flex items-center justify-center">
              <img
                src="/images/HPE Full.png"
                alt="HPE"
                className="w-full h-16 object-contain"
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow flex items-center justify-center">
              <img
                src="/images/Greenlake.png"
                alt="HPE GreenLake"
                className="w-full h-16 object-contain"
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow flex items-center justify-center">
              <img
                src="/images/Aruba.png"
                alt="Aruba Networks"
                className="w-full h-16 object-contain"
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow flex items-center justify-center">
              <img
                src="/images/Juniper.png"
                alt="Juniper Networks"
                className="w-full h-16 object-contain"
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow flex items-center justify-center">
              <img
                src="/images/Zerto.png"
                alt="Zerto"
                className="w-full h-16 object-contain"
              />
            </div>
            <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition-shadow flex items-center justify-center">
              <img
                src="/images/Opsramp.png"
                alt="OpsRamp"
                className="w-full h-16 object-contain"
              />
            </div>
          </div>

          {/* Descripción del Ecosistema */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="bg-allti-blue/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <CheckCircle className="text-allti-blue" size={24} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Infraestructura Core
              </h3>
              <p className="text-gray-600">
                Soluciones HPE para cómputo, almacenamiento y nube híbrida con
                GreenLake como plataforma central.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="bg-hpe-green/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <CheckCircle className="text-hpe-green" size={24} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Conectividad Inteligente
              </h3>
              <p className="text-gray-600">
                Redes empresariales con Aruba y Juniper, integrando IA para
                optimización y seguridad automatizada.
              </p>
            </div>

            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="bg-allti-red/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                <CheckCircle className="text-allti-red" size={24} />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                Gestión y Protección
              </h3>
              <p className="text-gray-600">
                Herramientas de monitoreo AIOps con OpsRamp y protección de
                datos empresariales con Zerto.
              </p>
            </div>
          </div>

          {/* CTA para ver detalles */}
          <div className="text-center mt-12">
            <a
              href="/soluciones"
              className="inline-flex items-center gap-2 bg-allti-blue text-white px-8 py-4 rounded-lg hover:bg-blue-700 transition-all shadow-lg hover:shadow-xl font-semibold"
            >
              Ver Soluciones Detalladas
              <ChevronRight size={20} />
            </a>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-r from-allti-blue to-blue-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            ¿Quieres conocer más sobre nosotros?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Contáctanos y descubre cómo podemos ayudarte a transformar tu
            infraestructura
          </p>
          <a
            href="/contacto"
            data-testid="nosotros-cta-btn"
            className="bg-white text-allti-blue px-8 py-4 rounded-lg hover:bg-gray-100 transition-colors text-lg font-semibold inline-block"
          >
            Contáctanos Ahora
          </a>
        </div>
      </section>
    </div>
  );
}
